module.exports = __webpack_public_path__ + "img/38d7cf983d6b438ba2930ab17f95a61e.38d7cf98.png";